import { Space, Typography } from 'antd'
import { CASNotificationEvent } from 'shared'

const CASNotificationsDetails: React.FC = () => {
  return (
    <Space direction="vertical">
      <Typography.Text>
        Approvers always receive notifications for{' '}
        {CASNotificationEvent.RoutedToGroupReview.name}, and if Routing Groups
        are edited outside the Submittal Tracker workflow.
      </Typography.Text>
    </Space>
  )
}

export default CASNotificationsDetails
